import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import SuccessActionIcon from './SuccessActionIcon';
import { SIDEBAR_ACTIONS } from '../../../../../../constants/actionsConstants';
import { toSidebarPlatformKey } from '../../../../../../services/inbox/inboxMsChatPlatform';

const SendByAction = ({
  order,
  platform,
  onSendPaymentLink,
  closeParentModal
}) => {
  const { t } = useTranslation('Orders');

  const dispatch = useDispatch();
  const basePlatform = toSidebarPlatformKey(platform) || platform;
  const icon = basePlatform === 'whatsapp' ? 'whatsapp-outline' : basePlatform === 'instagram' ? 'instagram-line' : 'messenger-line';

  const openModal = useCallback(() => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'SendByModal',
        props: {
          order,
          platform,
          onSendPaymentLink
        }
      }
    });

    closeParentModal();
  }, [closeParentModal, dispatch, onSendPaymentLink, order]);

  return (
    <div className="tw-flex tw-flex-col tw-items-center">
      <SuccessActionIcon
        icon={icon}
        title={t('orderSaved.sendBy')}
        subtitle={t(`sendBy.${basePlatform}`)}
        onClick={openModal}
      />
    </div>
  );
};

export default memo(SendByAction);
